import type { TenancyStatus } from "~/helpers/modules/rent-roll-helpers";

export type TenancyStatusOption<T extends TenancyStatus = TenancyStatus> = { id: T; name: string; color: "red" | "green" | "yellow" };

export const useTenancyStatusOptions = () => {
  const t = useTranslator();
  const filter = useFilter();

  return computed<{ [k in TenancyStatus]: TenancyStatusOption<k> }>(() => ({
    vacant: { id: "vacant", name: filter.capitalize(t("PORTFOLIO_VIEW_TENANCIES_VACANT")), color: "red" },
    occupiedTerminated: {
      id: "occupiedTerminated",
      name: filter.capitalize(`${t("PORTFOLIO_VIEW_TENANCIES_OCCUPIED")} ${t("AND")} ${t("PORTFOLIO_VIEW_TENANCIES_TERMINATED")}`),
      color: "yellow",
    },
    occupiedNotTerminated: {
      id: "occupiedNotTerminated",
      name: filter.capitalize(`${t("PORTFOLIO_VIEW_TENANCIES_OCCUPIED")} ${t("NOT")} ${t("PORTFOLIO_VIEW_TENANCIES_TERMINATED")}`),
      color: "green",
    },
  }));
};
